import { stringify } from 'query-string';
import DefaultMapper, { toPagingAndSorting } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class IdDocumentMapper extends DefaultMapper {
	mapResource({ resource, params }) {
		return 'user/users/iddocuments';
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		// If no ID is given, it is used from the dashboard and is supposed to show unprocessed documents
		if (!params.filter.userId) {
			const query = {
				...toPagingAndSorting(params),
				unprocessed: true,
			};
			options.url = `${API_BASE_PATH_ADMIN}/user/users/iddocuments?${stringify(query)}`;
		} else {
			// The list is embedded into the user details
			const query = {
				...toPagingAndSorting(params),
				userId: params.filter.userId
			};
			options.url = `${API_BASE_PATH_ADMIN}/user/users/${params.filter.userId}/iddocuments?${stringify(query)}`;
		}
	}
}

export default IdDocumentMapper
